export default __webpack_public_path__ + "static/huffington-post-grey-724cde4f51bc6dac3be0c3fc9e3feb38.svg";